import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const CSS_Fonts = () => {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">🎨 CSS Fonts</h1>

      {/* Intro Section with Gradient */}
      <div
        style={{
          background: "linear-gradient(135deg, #d1fae5, #bbf7d0)",
          padding: "1rem",
          borderRadius: "12px",
          marginBottom: "2rem",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#166534", marginBottom: "0.5rem" }}>
          ✨ Why Fonts Matter?
        </h2>
        <p style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
          Fonts define the look and feel of your text. A good font choice makes
          your website <strong>readable, professional, and attractive</strong>.
          CSS gives you full control over fonts — from family, size, weight, and
          style to advanced properties like spacing and shadow.
        </p>
      </div>

      {/* Font Properties Overview */}
      <div className="tutorial-section">
        <h2 className="section-title">📘 Common Font Properties</h2>
        <ul className="tutorial-list">
          <li>
            <a href="/css/fonts-family" className="learn-more">
              font-family
            </a>{" "}
            – Defines the typeface of the text.
          </li>
          <li>
            <a href="/css/fonts-size" className="learn-more">
              font-size
            </a>{" "}
            – Controls the size of the text.
          </li>
          <li>
            <a href="/css/fonts-style" className="learn-more">
              font-style
            </a>{" "}
            – Normal, italic, or oblique text.
          </li>
          <li>
            <a href="/css/fonts-weight" className="learn-more">
              font-weight
            </a>{" "}
            – Sets how bold or light the text appears.
          </li>
          <li>
            <a href="/css/fonts-variant" className="learn-more">
              font-variant
            </a>{" "}
            – Small caps and other stylistic options.
          </li>
          <li>
            <a href="/css/fonts-shorthand" className="learn-more">
              font (shorthand)
            </a>{" "}
            – Set multiple font properties in one line.
          </li>
        </ul>
      </div>

      {/* Example Preview */}
      <div className="tutorial-section">
        <h2 className="section-title">👨‍💻 Example</h2>
        <p>
          Here’s a quick example showing how different font properties work
          together:
        </p>
        <CodeCopyBlock
          code={`h1 {
  font-family: "Georgia", serif;
  font-size: 28px;
  font-style: italic;
  font-weight: bold;
}`}
        />

        <h3
          style={{
            fontFamily: "Georgia, serif",
            fontSize: "28px",
            fontStyle: "italic",
            fontWeight: "bold",
            background: "#f0fdf4",
            padding: "0.5rem",
            borderRadius: "8px",
          }}
        >
          This is styled with CSS Fonts ✨
        </h3>
      </div>

      {/* Best Practices */}
      <div className="tutorial-section">
        <h2 className="section-title">✅ Best Practices</h2>
        <ul className="tutorial-list">
          <li>
            Always provide <strong>fallback fonts</strong> (e.g.,
            <code>"Arial", sans-serif</code>).
          </li>
          <li>
            Use <strong>web-safe fonts</strong> for better browser support.
          </li>
          <li>
            Avoid using too many different fonts on one page — stick to 2 or 3
            max.
          </li>
          <li>
            Choose fonts that match the purpose of your site (formal, playful,
            techy, etc.).
          </li>
        </ul>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">🚀 Next Steps</h2>
        <p>
          Start with{" "}
          <a href="/css/fonts-family" className="learn-more">
            Font Family
          </a>{" "}
          to learn how to select and apply fonts to your website text.
        </p>
      </div>
    </div>
  );
};

export default CSS_Fonts;
